import RouteNames from "@/entities/RouteNames";
import { getChildRoutes } from "@/helpers/routes/getChildRoutes";
import BreadcrumbsTitles from "@/entities/BreadcrumbsTitles";
import NavigationIcons from "@/entities/NavigationIcons";
import RouteWrapper from "@/components/common/RouteWrapper.vue";
import { GetRelativeRoutes } from "@/entities/GetChildRoutes";
import Roles from "@/entities/Roles";

const ContractorCompanies = () =>
  import("@/components/company/ContractorCompanies.vue").then((m) => m.default);
const Company = () =>
  import("@/views/network/CompanyPublicPage.vue").then((m) => m.default);

const getCompaniesRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: "/companies",
    component: RouteWrapper,
    meta: {
      breadcrumb: {
        title: BreadcrumbsTitles.COMPANIES,
        icon: NavigationIcons.COMPANIES,
        routeName: RouteNames.NETWORK_COMPANIES,
        isStyled: true,
      },
    },
    children: [
      {
        path: "",
        name: RouteNames.NETWORK_COMPANIES,
        component: ContractorCompanies,
        meta: {
          title: "Companies",
          roles: [Roles.CONTRACTOR],
          breadcrumb: {
            isStyled: true,
          },
        },
      },
    ],
  },
]);

const getCompanyPrivatePageRoutes: GetRelativeRoutes = getChildRoutes([
  {
    path: ":id",
    name: RouteNames.NETWORK_COMPANY,
    component: Company,
    meta: {
      title: "Company",
      roles: [Roles.CONTRACTOR],
      breadcrumb: {
        title: BreadcrumbsTitles.COMPANY_DETAILS,
        isStyled: true,
      },
    },
  },
]);

export { getCompanyPrivatePageRoutes, getCompaniesRoutes };
